export const build = { date:"2026-05-27.1313", stage:"alpha" }
